module.exports = __webpack_public_path__ + "img/11.3b2184ed.jpg";